import React, { useState } from "react";
import { SocailMain, SocialLiDiv } from "./socialElement";
import { useAppDispatch, useAppSelector } from "store/store";

import {
  BsTwitter,
  AiOutlineCopy,
  BsFacebook,
  IoMdRefresh,
  MdWeb,
  AiFillFlag,
  BsThreeDotsVertical,
  BsShareFill,
} from "react-icons/all";

import {
  Dropdowns,
  DropdownMenu,
  DropdownItem,
  DropdownItemA,
  Buttons,
  ToastMessage,
} from "components/common";

import { MainModel } from "components";

// redux Slice
import {
  mainModel,
  reportModelSlice,
} from "store/redux/slices/helperSlices/modelSlice";

type Props = {
  sharebtn?: boolean;
  setRefetchData?: any;
  refetchData?: any;
  nftId?: String;
};

const SocialMenu: React.FC<Props> = ({
  refetchData,
  nftId,
}: {
  refetchData?: any;
  nftId?: string;
}) => {
  const clipToCopy = () => {
    ToastMessage("Copied", "Success", "success");
    navigator.clipboard.writeText(window?.location?.href);
  };
  const { web3 } = useAppSelector((state) => state.web3Connect);
  const menu = (
    <DropdownMenu>
      <DropdownItem>
        <BsFacebook
          style={{
            fontSize: "1.2rem",
            marginTop: "-0.2rem",
            marginLeft: "0.5rem",
          }}
        />

        <DropdownItemA
          href={`https://www.facebook.com/sharer/sharer.php?u=${window?.location?.href}`}
          target="_blank"
        >
          Share
        </DropdownItemA>
      </DropdownItem>
      <hr style={{ marginTop: "0.5rem" }} />
      <DropdownItem style={{ marginTop: "-0.8rem" }}>
        <BsTwitter
          style={{
            fontSize: "1.2rem",
            marginTop: "rem",
            marginLeft: "0.5rem",
          }}
        />
        <DropdownItemA
          // rel="noopener noreferrer"
          href={`https://twitter.com/intent/tweet?text=${window?.location?.href}`}
          target="_blank"
        >
          Share
        </DropdownItemA>
      </DropdownItem>
      <hr style={{ marginTop: "0.5rem" }} />

      <DropdownItem style={{ marginTop: "-0.8rem" }} onClick={clipToCopy}>
        <AiOutlineCopy
          style={{
            fontSize: "1.2rem",
            marginTop: "0rem",
            marginLeft: "0.5rem",
          }}
        />

        <DropdownItemA> Copy </DropdownItemA>
      </DropdownItem>
    </DropdownMenu>
  );

  const dispatch = useAppDispatch();
  const report = () => {
    web3 && dispatch(reportModelSlice({ state: true, nftId }));
  };

  const ReportMenu = (
    <DropdownMenu>
      <DropdownItem
        disabled={!web3 ? true : false}
        style={{ cursor: web3 ? "pointer" : "not-allowed" }}
        onClick={report}
      >
        <AiFillFlag
          style={{
            fontSize: "1.2rem",
            marginTop: "-0.2rem",
            marginLeft: "0.5rem",
          }}
        />

        <DropdownItemA> Report</DropdownItemA>
      </DropdownItem>
    </DropdownMenu>
  );

  return (
    <div>
      <MainModel />
      <SocailMain>
        <SocialLiDiv className="firstSocial">
          <IoMdRefresh color="#000" onClick={()=>refetchData()} />
        </SocialLiDiv>

        <Dropdowns overlay={menu} trigger={["click"]}>
          <Buttons sharebtn>
            <BsShareFill color="#000" />
          </Buttons>
        </Dropdowns>
        <Dropdowns overlay={ReportMenu} trigger={["click"]}>
          <Buttons>
            <BsThreeDotsVertical color="#000" />
          </Buttons>
        </Dropdowns>
      </SocailMain>
    </div>
  );
};

export default SocialMenu;
